import React from 'react'

function AppDev() {
  return (
    <>
      <head>
        <title>نصنع لك تطبيق أحلامك!</title>
        <meta name="description" content="في بروتك المتحدة، نطور تطبيقات جوال عالية الجودة تعمل على جميع المنصات بأحدث التقنيات مثل Flutter  مما يضمن تجربة مستخدم سلسة وأداءً فائقًا." />
      </head>
      <div>
        <h1>هل تريد تطبيقًا خاصًا بشركتك أو فكرتك؟ عندنا الحل!</h1>
        <ol>
          <li>نوّفر تطبيقات سريعة وسهلة الاستخدام.
          </li>
          <li>نشتغل على نظام الأندرويد والآيفون مع بعض.</li>
          <li> التطبيق راح يكون زين ويشتغل بطلاقة بدون مشاكل.</li>
          <li> تقدر تتابع معنا خطوة بخطوة لحد ما يطلع بالشكل اللي تبيه.
          </li>
        </ol>
        <br />
        خلنا نسوي لك التطبيق اللي يخلي عملاءك يمدحونك!

      </div>
    </>
  )
}

export default AppDev